import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MessageCircle, X, Sparkles } from 'lucide-react';
import ChatBot from './ChatBot';

const ChatBotToggle = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 32000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="fixed bottom-6 right-6 z-50">
      <div className="relative">
        <motion.button
          onClick={() => {
            setIsVisible(prev => !prev);
            if (isFirstLoad) setIsFirstLoad(false);
          }}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          className="p-4 rounded-full bg-gradient-to-r from-purple-500 to-violet-500 shadow-lg shadow-purple-500/30 text-white hover:shadow-xl hover:shadow-purple-500/40 transition-all duration-300 relative overflow-hidden group"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          aria-label="Toggle ChatBot"
        >
          <div className="absolute inset-0 bg-gradient-to-r from-purple-400/50 to-violet-400/50 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
          <div className="relative z-10 flex items-center justify-center">
            {isVisible ? <X size={24} /> : <MessageCircle size={24} />}
          </div>
          <motion.div 
            className="absolute -top-1 -right-1"
            animate={{ rotate: 360 }}
            transition={{ duration: 2, repeat: Infinity, ease: "linear" }}
          >
            <Sparkles className="w-4 h-4 text-purple-200" />
          </motion.div>
        </motion.button>
        
        {isHovered && !isVisible && (
          <motion.div
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            className="absolute bottom-full right-0 mb-2 px-4 py-2 bg-white/10 backdrop-blur-md rounded-lg shadow-lg border border-white/20"
          >
            <p className="text-sm text-purple-200 whitespace-nowrap font-medium">Need marketing help?</p>
          </motion.div>
        )}
      </div>

      <AnimatePresence>
        {isVisible && (
          <motion.div
            className="fixed bottom-24 right-6"
            initial={{ opacity: 0, scale: 0.95, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.95, y: 20 }}
            transition={{ duration: 0.3, ease: [0.4, 0, 0.2, 1] }}
          >
            <ChatBot isFirstLoad={isFirstLoad} />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default ChatBotToggle;